/**
 * Walk / drive times for explore (nearby) shop cards — matches API haversine heuristics when fields are absent.
 */

function estimateWalkMinutesFromMeters(m) {
  if (m == null || !Number.isFinite(Number(m))) return null;
  const km = Number(m) / 1000;
  const roadKm = km * 1.15;
  const mins = Math.round((roadKm / 5) * 60);
  return Math.max(1, Math.min(180, mins));
}

/** Matches API haversine driving heuristic (urban detour + ~27 km/h). */
function estimateDrivingMinutesFromMeters(m) {
  if (m == null || !Number.isFinite(Number(m))) return null;
  const km = Number(m) / 1000;
  const roadKm = km * 1.2;
  const mins = Math.round((roadKm / 27) * 60);
  return Math.max(1, Math.min(180, mins));
}

/**
 * @returns {{ walk: number | null, drive: number | null }}
 */
export function getWalkDriveMinutes(shop) {
  const drive =
    typeof shop?.travelMinutesDrive === "number" && shop.travelMinutesDrive > 0
      ? shop.travelMinutesDrive
      : typeof shop?.travelMinutesEstimate === "number" && shop.travelMinutesEstimate > 0
        ? shop.travelMinutesEstimate
        : null;

  let walk =
    typeof shop?.travelMinutesWalk === "number" && shop.travelMinutesWalk > 0
      ? shop.travelMinutesWalk
      : null;

  if (walk == null && typeof shop?.distanceMeters === "number" && Number.isFinite(shop.distanceMeters)) {
    walk = estimateWalkMinutesFromMeters(shop.distanceMeters);
  }

  return { walk, drive };
}

/**
 * Drive time from the departure address to this restaurant.
 * Planning uses that restaurant road time. A fraction of the drive to the
 * final address, and the straight-line estimate, are only fallbacks.
 */
export function getDriveMinutesFromDeparture(shop) {
  const toRestaurant = Number(shop?.smartRoute?.originDriveMinutes);
  if (Number.isFinite(toRestaurant) && toRestaurant > 0) return Math.round(toRestaurant);

  const routed = Number(shop?.smartRoute?.routeOffsetMinutes);
  if (
    shop?.smartRoute?.isDestinationRestaurant === true &&
    Number.isFinite(routed) &&
    routed > 0
  ) {
    return Math.round(routed);
  }
  const { drive } = getWalkDriveMinutes(shop);
  if (drive != null) return drive;
  if (typeof shop?.distanceMeters === "number" && Number.isFinite(shop.distanceMeters)) {
    const est = estimateDrivingMinutesFromMeters(shop.distanceMeters);
    if (est != null) return est;
  }
  const routeMin = Number(shop?.smartRoute?.routeOffsetMinutes);
  return Number.isFinite(routeMin) && routeMin >= 0 ? routeMin : 0;
}
